import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const raffleApi = {
  getAll: () => api.get('/raffles'),
  getById: (id) => api.get(`/raffles/${id}`),
};

export const purchaseApi = {
  create: (data) => api.post('/purchases', data),
};

export const adminApi = {
  getRaffles: () => api.get('/admin/raffles'),
  createRaffle: (data) => api.post('/admin/raffles', data),
  updateRaffle: (id, data) => api.patch(`/admin/raffles/${id}`, data),
  deleteRaffle: (id) => api.delete(`/admin/raffles/${id}`),
  getPurchases: () => api.get('/admin/purchases'),
  confirmPurchase: (id) => api.patch(`/admin/purchases/${id}/confirm`),
  cancelPurchase: (id) => api.patch(`/admin/purchases/${id}/cancel`),
  getStats: () => api.get('/admin/stats'),
};

export default api;
